<template>
  <div>
    <div class="top_image_container">
      <div class="background_image_container">
        <img src="img/profile-background.jpg" class="background_img" alt="Background Image"/>
      </div>

      <div class="imgContainerSuperioMain">
        <img :src="fotoSrc" class="imgContainerSuperior" alt="Profile Image"/>
        <PesquisarEstudante @estudanteEscolhido="handleSelectedStudent" :redColorActive="emptyStudent"/>
        <ContainerOpcoes @selectedOptionMenu="handleSelectedOption" :userSelectedBottom="selectedButtom"/>
      </div>
    </div>
  </div>
</template>

<script>
import PesquisarEstudante from "../estudantes/PesquisarEstudante.vue";
import ContainerOpcoes from "./ContainerOpcoes.vue";
const ls = require('local-storage')

export default {
  components: {
    PesquisarEstudante,
    ContainerOpcoes
  },
  data() {
    return {
       StudentSelected: null,
      foto: "img/estudanteImagem.jpg",
      emptyStudent: false
    };
  },
  computed: {
    fotoSrc() {      
      // return this.StudentSelected  ? ls.get('urlFoto')+'readphotoBySigla/'+this.StudentSelected.numero_matricula+'.png/'+ls.get('sigla') : this.foto;
      return this.foto;
    },

    urlFoto (){
      return ls.get('urlFoto')
    },

    isStudentValid() {
      return !this.StudentSelected;
    }
  },

  created(){
     
  },

  props: {
    selectedButtom: undefined
  },
  methods: {
    handleSelectedStudent(estudante) {
      this.StudentSelected = estudante;      
      this.$emit('selectedStudent', estudante);
    },

    handleSelectedOption(option) {
      if (option === 2 || !this.isStudentValid) {
        this.emptyStudent = false;
        this.$emit('selectedMenu', option);
      } else {
        this.emptyStudent = this.isStudentValid;
      }
    }
  }
};
</script>

<style scoped>
.top_image_container {
  width: 100%;
    background-color: #fff;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 20px;
}

.background_image_container {
  height: 150px;
  width: 100%;
}

.background_image_container .background_img {
  height: 100%;
  width: 100%;
}

.imgContainerSuperior {
  width: 10rem;
  border-width: 0.25rem;
  border-color: #fff;
  border-radius: 50%;
}

.imgContainerSuperioMain {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: -100px;
}
</style>
